import { render, staticRenderFns } from "./mallProList.vue?vue&type=template&id=15634047&scoped=true&"
import script from "./mallProList.vue?vue&type=script&lang=ts&"
export * from "./mallProList.vue?vue&type=script&lang=ts&"
import style0 from "./mallProList.vue?vue&type=style&index=0&lang=less&"
import style1 from "./mallProList.vue?vue&type=style&index=1&id=15634047&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15634047",
  null
  
)

export default component.exports